<template>
    <div class="templete">
        <div class="tabs">
            <div class="item" :class="{ 'active' : current == 0 } " @click="current = 0">销售确认单</div>
            <div class="item" :class="{ 'active' : current == 1 } " @click="current = 1">销售单(应收)</div>
            <div class="item" :class="{ 'active' : current == 2 } " @click="current = 2">送货单</div>
            <div class="item" :class="{ 'active' : current == 3 } " @click="current = 3">采购单</div>
            <div class="item" :class="{ 'active' : current == 4 } " @click="current = 4">退货单</div>
        </div>
        <div class="">
            <sale-confirm-bill v-show="current == 0"></sale-confirm-bill>
            <sale-bill v-show="current == 1"></sale-bill>
            <delivery-bill v-show="current == 2"></delivery-bill>
            <purchase-bill v-show="current == 3"></purchase-bill>
            <back-bill v-show="current == 4"></back-bill>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
    }
    .templete{overflow: auto;}
    .tabs{
        display: flex; align-items: center; 
        .item {border-radius: 3px;
            font-size:14px; color: #333333; cursor: pointer; border: 1px solid #333333; padding: 5px 15px;
            &.active{ border: 1px solid #B21111;background-color: #B21111;color:#fff;}
        }
        .item + .item{ margin-left: 30px; }
    }
    .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
</style>
<script>
import saleConfirmBill from '../../components/setting/saleconfirmbill.vue'
import saleBill from '../../components/setting/summarySet.vue'
import deliveryBill from '../../components/setting/deliverybill.vue'
import purchaseBill from '../../components/setting/purchaseBill.vue'
import backBill from '../../components/setting/backbill.vue'
    export default {
        components:{
            saleConfirmBill,
            saleBill,
            deliveryBill,
            purchaseBill,
            backBill
        },
        data(){
            return{
                current : 0,
            }
        }
    }
</script>
